export interface ISurah {
	id: number;
	name: string;
	ohneharakat: string;
	firstVerseId: number;
	lastVerseId: number;
	withoutHarakat: string;
	firstPage: number;
	lastPage: number;
}

export interface IAaya {
	id: string;
	number: string;
	number_in_surah: string;
	text: string;
	firstPage: string;
	surah_id: string;
	hizb_id: string;
	juz_id: string;
	sajda: string;
	created_at: string;
	updated_at: string;
}

export const surah: ISurah[] = [
	{
		id: 1,
		firstVerseId: 1,
		lastVerseId: 7,
		name: 'Al-Fatiha',
		ohneharakat: 'سورة الفَاتِحَة',
		withoutHarakat: 'سورة الفاتحة',
		firstPage: 1,
		lastPage: 1,
	},
	{
		id: 2,
		firstVerseId: 8,
		lastVerseId: 293,
		name: 'Al-Baqara',
		ohneharakat: 'سورة البَقَرَة',
		withoutHarakat: 'سورة البقرة',
		firstPage: 2,
		lastPage: 49,
	},
	{
		id: 3,
		firstVerseId: 294,
		lastVerseId: 493,
		name: 'Aal-e-Imran',
		ohneharakat: 'سورة عِمرَان',
		withoutHarakat: 'سورة آل عمران',
		firstPage: 50,
		lastPage: 76,
	},
	{
		id: 4,
		firstVerseId: 494,
		lastVerseId: 669,
		name: 'An-Nisa',
		ohneharakat: 'سورة النِّسَاء',
		withoutHarakat: 'سورة النساء',
		firstPage: 77,
		lastPage: 106,
	},
	{
		id: 5,
		firstVerseId: 670,
		lastVerseId: 789,
		name: 'Al-Maeda',
		ohneharakat: 'سورة المَائدة',
		withoutHarakat: 'سورة المائدة',
		firstPage: 106,
		lastPage: 127,
	},
	{
		id: 6,
		firstVerseId: 790,
		lastVerseId: 954,
		name: 'Al-Anaam',
		ohneharakat: 'سورة الأنعَام',
		withoutHarakat: 'سورة الأنعام',
		firstPage: 128,
		lastPage: 150,
	},
	{
		id: 7,
		firstVerseId: 955,
		lastVerseId: 1160,
		name: 'Al-Araf',
		ohneharakat: 'سورة الأعرَاف',
		withoutHarakat: 'سورة الأعراف',
		firstPage: 151,
		lastPage: 176,
	},
	{
		id: 8,
		firstVerseId: 1161,
		lastVerseId: 1235,
		name: 'Al-Anfal',
		ohneharakat: 'سورة الأنفَال',
		withoutHarakat: 'سورة الأنفال',
		firstPage: 177,
		lastPage: 186,
	},
	{
		id: 9,
		firstVerseId: 1236,
		lastVerseId: 1364,
		name: 'At-Taubah',
		ohneharakat: 'سورة التوبَة',
		withoutHarakat: 'سورة التوبة',
		firstPage: 187,
		lastPage: 207,
	},
	{
		id: 10,
		firstVerseId: 1365,
		lastVerseId: 1473,
		name: ' Yunus ',
		ohneharakat: 'سورة يُونس',
		withoutHarakat: 'سورة يونس',
		firstPage: 208,
		lastPage: 220,
	},
	{
		id: 11,
		firstVerseId: 1474,
		lastVerseId: 1596,
		name: 'Hud',
		ohneharakat: 'سورة هُود',
		withoutHarakat: 'سورة هود',
		firstPage: 221,
		lastPage: 234,
	},
	{
		id: 12,
		firstVerseId: 1597,
		lastVerseId: 1707,
		name: 'Yusuf',
		ohneharakat: 'سورة يُوسُف',
		withoutHarakat: 'سورة يوسف',
		firstPage: 235,
		lastPage: 248,
	},
	{
		id: 13,
		firstVerseId: 1708,
		lastVerseId: 1750,
		name: 'Ar-Rad',
		ohneharakat: 'سورة الرَّعْد',
		withoutHarakat: 'سورة الرعد',
		firstPage: 249,
		lastPage: 255,
	},
	{
		id: 14,
		firstVerseId: 1751,
		lastVerseId: 1802,
		name: 'Ibrahim',
		ohneharakat: 'سورة إبراهِيم',
		withoutHarakat: 'سورة إبراهيم',
		firstPage: 255,
		lastPage: 261,
	},
	{
		id: 15,
		firstVerseId: 1803,
		lastVerseId: 1901,
		name: 'Al-Hijr',
		ohneharakat: 'سورة الحِجْر',
		withoutHarakat: 'سورة الحجر',
		firstPage: 262,
		lastPage: 267,
	},
	{
		id: 16,
		firstVerseId: 1902,
		lastVerseId: 2029,
		name: 'An-Nahl',
		ohneharakat: 'سورة النَّحْل',
		withoutHarakat: 'سورة النحل',
		firstPage: 267,
		lastPage: 281,
	},
	{
		id: 17,
		firstVerseId: 2030,
		lastVerseId: 2140,
		name: 'Al-Isra',
		ohneharakat: 'سورة الإسْرَاء',
		withoutHarakat: 'سورة الإسراء',
		firstPage: 282,
		lastPage: 293,
	},
	{
		id: 18,
		firstVerseId: 2141,
		lastVerseId: 2250,
		name: 'Al-Kahf',
		ohneharakat: 'سورة الكهْف',
		withoutHarakat: 'سورة الكهف',
		firstPage: 293,
		lastPage: 304,
	},
	{
		id: 19,
		firstVerseId: 2251,
		lastVerseId: 2348,
		name: 'Maryam',
		ohneharakat: 'سورة مَريَم',
		withoutHarakat: 'سورة مريم',
		firstPage: 304,
		lastPage: 312,
	},
	{
		id: 20,
		firstVerseId: 2349,
		lastVerseId: 2483,
		name: 'Taha',
		ohneharakat: 'سورة طه',
		withoutHarakat: 'سورة طه',
		firstPage: 312,
		lastPage: 321,
	},
	{
		id: 21,
		firstVerseId: 2484,
		lastVerseId: 2595,
		name: 'Al-Anbiya',
		ohneharakat: 'سورة الأنبيَاء',
		withoutHarakat: 'سورة الانبياء',
		firstPage: 322,
		lastPage: 331,
	},
	{
		id: 22,
		firstVerseId: 2596,
		lastVerseId: 2673,
		name: 'Al-Hajj',
		ohneharakat: 'سورة الحَج',
		withoutHarakat: 'سورة الحج',
		firstPage: 332,
		lastPage: 341,
	},
	{
		id: 23,
		firstVerseId: 2674,
		lastVerseId: 2791,
		name: 'Al-Mumenoon',
		ohneharakat: 'سورة المُؤمنون',
		withoutHarakat: 'سورة المؤمنون',
		firstPage: 342,
		lastPage: 349,
	},
	{
		id: 24,
		firstVerseId: 2792,
		lastVerseId: 2855,
		name: 'An-Noor',
		ohneharakat: 'سورة النُّور',
		withoutHarakat: 'سورة النور',
		firstPage: 350,
		lastPage: 359,
	},
	{
		id: 25,
		firstVerseId: 2856,
		lastVerseId: 2932,
		name: 'Al-Furqan',
		ohneharakat: 'سورة الفُرْقان',
		withoutHarakat: 'سورة الفرقان',
		firstPage: 359,
		lastPage: 366,
	},
	{
		id: 26,
		firstVerseId: 2933,
		lastVerseId: 3159,
		name: 'Ash-Shuara',
		ohneharakat: 'سورة الشُّعَرَاء',
		withoutHarakat: 'سورة الشعراء',
		firstPage: 367,
		lastPage: 376,
	},
	{
		id: 27,
		firstVerseId: 3160,
		lastVerseId: 3252,
		name: 'An-Naml',
		ohneharakat: 'سورة النَّمْل',
		withoutHarakat: 'سورة النمل',
		firstPage: 377,
		lastPage: 385,
	},
	{
		id: 28,
		firstVerseId: 3253,
		lastVerseId: 3340,
		name: 'Al-Qasas',
		ohneharakat: 'سورة القَصَص',
		withoutHarakat: 'سورة القصص',
		firstPage: 385,
		lastPage: 396,
	},
	{
		id: 29,
		firstVerseId: 3341,
		lastVerseId: 3409,
		name: 'Al-Ankaboot',
		ohneharakat: 'سورة العَنكبوت',
		withoutHarakat: 'سورة العنكبوت',
		firstPage: 396,
		lastPage: 404,
	},
	{
		id: 30,
		firstVerseId: 3410,
		lastVerseId: 3469,
		name: 'Ar-Room',
		ohneharakat: 'سورة الرُّوم',
		withoutHarakat: 'سورة الروم',
		firstPage: 404,
		lastPage: 410,
	},
	{
		id: 31,
		firstVerseId: 3470,
		lastVerseId: 3503,
		name: 'Luqman',
		ohneharakat: 'سورة لقمَان',
		withoutHarakat: 'سورة لقمان',
		firstPage: 411,
		lastPage: 414,
	},
	{
		id: 32,
		firstVerseId: 3504,
		lastVerseId: 3533,
		name: 'As-Sajda',
		ohneharakat: 'سورة السَّجدَة',
		withoutHarakat: 'سورة السجدة',
		firstPage: 415,
		lastPage: 417,
	},
	{
		id: 33,
		firstVerseId: 3534,
		lastVerseId: 3606,
		name: 'Al-Ahzab',
		ohneharakat: 'سورة الأحزَاب',
		withoutHarakat: 'سورة الاحزاب',
		firstPage: 418,
		lastPage: 427,
	},
	{
		id: 34,
		firstVerseId: 3607,
		lastVerseId: 3660,
		name: 'Saba',
		ohneharakat: 'سورة سَبَأ',
		withoutHarakat: 'سورة سبا',
		firstPage: 428,
		lastPage: 434,
	},
	{
		id: 35,
		firstVerseId: 3661,
		lastVerseId: 3705,
		name: 'Fatir',
		ohneharakat: 'سورة فَاطِر',
		withoutHarakat: 'سورة فاطر',
		firstPage: 434,
		lastPage: 440,
	},
	{
		id: 36,
		firstVerseId: 3706,
		lastVerseId: 3788,
		name: 'Ya-Seen',
		ohneharakat: 'سورة يس',
		withoutHarakat: 'سورة يس',
		firstPage: 440,
		lastPage: 445,
	},
	{
		id: 37,
		firstVerseId: 3789,
		lastVerseId: 3970,
		name: 'As-Saaffat',
		ohneharakat: 'سورة الصَّافات',
		withoutHarakat: 'سورة الصافات',
		firstPage: 446,
		lastPage: 452,
	},
	{
		id: 38,
		firstVerseId: 3971,
		lastVerseId: 4058,
		name: 'Sad',
		ohneharakat: 'سورة ص',
		withoutHarakat: 'سورة ص',
		firstPage: 453,
		lastPage: 458,
	},
	{
		id: 39,
		firstVerseId: 4059,
		lastVerseId: 4133,
		name: 'Az-Zumar',
		ohneharakat: 'سورة الزُّمَر',
		withoutHarakat: 'سورة الزمر',
		firstPage: 458,
		lastPage: 467,
	},
	{
		id: 40,
		firstVerseId: 4134,
		lastVerseId: 4218,
		name: 'Ghafir',
		ohneharakat: 'سورة غَافِر',
		withoutHarakat: 'سورة غافر',
		firstPage: 467,
		lastPage: 476,
	},
	{
		id: 41,
		firstVerseId: 4219,
		lastVerseId: 4272,
		name: 'Fussilat',
		ohneharakat: 'سورة فُصِّلَتْ',
		withoutHarakat: 'سورة فصلت',
		firstPage: 477,
		lastPage: 482,
	},
	{
		id: 42,
		firstVerseId: 4273,
		lastVerseId: 4325,
		name: 'Ash-Shura',
		ohneharakat: 'سورة الشُّورَى',
		withoutHarakat: 'سورة الشورى',
		firstPage: 483,
		lastPage: 489,
	},
	{
		id: 43,
		firstVerseId: 4326,
		lastVerseId: 4414,
		name: 'Az-Zukhruf',
		ohneharakat: 'سورة الزُّخْرُف',
		withoutHarakat: 'سورة الزخرف',
		firstPage: 489,
		lastPage: 495,
	},
	{
		id: 44,
		firstVerseId: 4415,
		lastVerseId: 4473,
		name: 'Ad-Dukhan',
		ohneharakat: 'سورة الدخَان',
		withoutHarakat: 'سورة الدخان',
		firstPage: 496,
		lastPage: 498,
	},
	{
		id: 45,
		firstVerseId: 4474,
		lastVerseId: 4510,
		name: 'Al-Jathiya',
		ohneharakat: 'سورة الجَاثيَة',
		withoutHarakat: 'سورة الجاثية',
		firstPage: 499,
		lastPage: 502,
	},
	{
		id: 46,
		firstVerseId: 4511,
		lastVerseId: 4545,
		name: 'Al-Ahqaf',
		ohneharakat: 'سورة الأحْقاف',
		withoutHarakat: 'سورة الاحقاف',
		firstPage: 502,
		lastPage: 506,
	},
	{
		id: 47,
		firstVerseId: 4546,
		lastVerseId: 4583,
		name: 'Muhammad',
		ohneharakat: 'سورة محَمَّد',
		withoutHarakat: 'سورة محمد',
		firstPage: 507,
		lastPage: 510,
	},
	{
		id: 48,
		firstVerseId: 4584,
		lastVerseId: 4612,
		name: 'Al-Fath',
		ohneharakat: 'سورة الفَتْح',
		withoutHarakat: 'سورة الفتح',
		firstPage: 511,
		lastPage: 515,
	},
	{
		id: 49,
		firstVerseId: 4613,
		lastVerseId: 4630,
		name: 'Al-Hujraat',
		ohneharakat: 'سورة الحُجرَات',
		withoutHarakat: 'سورة الحجرات',
		firstPage: 515,
		lastPage: 517,
	},
	{
		id: 50,
		firstVerseId: 4631,
		lastVerseId: 4675,
		name: 'Qaf',
		ohneharakat: 'سورة ق',
		withoutHarakat: 'سورة ق',
		firstPage: 518,
		lastPage: 520,
	},
	{
		id: 51,
		firstVerseId: 4676,
		lastVerseId: 4735,
		name: 'Adh-Dhariyat',
		ohneharakat: 'سورة الذَّاريَات',
		withoutHarakat: 'سورة الذاريات',
		firstPage: 520,
		lastPage: 523,
	},
	{
		id: 52,
		firstVerseId: 4736,
		lastVerseId: 4784,
		name: 'At-Tur',
		ohneharakat: 'سورة الطُّور',
		withoutHarakat: 'سورة الطور',
		firstPage: 523,
		lastPage: 525,
	},
	{
		id: 53,
		firstVerseId: 4785,
		lastVerseId: 4846,
		name: 'An-Najm',
		ohneharakat: 'سورة النَّجْم',
		withoutHarakat: 'سورة النجم',
		firstPage: 526,
		lastPage: 528,
	},
	{
		id: 54,
		firstVerseId: 4847,
		lastVerseId: 4901,
		name: 'Al-Qamar',
		ohneharakat: 'سورة القَمَر',
		withoutHarakat: 'سورة القمر',
		firstPage: 528,
		lastPage: 531,
	},
	{
		id: 55,
		firstVerseId: 4902,
		lastVerseId: 4979,
		name: 'Ar-Rahman',
		ohneharakat: 'سورة الرَّحمن',
		withoutHarakat: 'سورة الرحمن',
		firstPage: 531,
		lastPage: 534,
	},
	{
		id: 56,
		firstVerseId: 4980,
		lastVerseId: 5075,
		name: 'Al-Waqia',
		ohneharakat: 'سورة الوَاقِعَة',
		withoutHarakat: 'سورة الواقعة',
		firstPage: 534,
		lastPage: 537,
	},
	{
		id: 57,
		firstVerseId: 5076,
		lastVerseId: 5104,
		name: 'Al-Hadid',
		ohneharakat: 'سورة الحَديد',
		withoutHarakat: 'سورة الحديد',
		firstPage: 537,
		lastPage: 541,
	},
	{
		id: 58,
		firstVerseId: 5105,
		lastVerseId: 5126,
		name: 'Al-Mujadila',
		ohneharakat: 'سورة المجَادلة',
		withoutHarakat: 'سورة المجادلة',
		firstPage: 542,
		lastPage: 545,
	},
	{
		id: 59,
		firstVerseId: 5127,
		lastVerseId: 5150,
		name: 'Al-Hashr',
		ohneharakat: 'سورة الحَشر',
		withoutHarakat: 'سورة الحشر',
		firstPage: 545,
		lastPage: 548,
	},
	{
		id: 60,
		firstVerseId: 5151,
		lastVerseId: 5163,
		name: 'Al-Mumtahina',
		ohneharakat: 'سورة المُمتَحنَة',
		withoutHarakat: 'سورة الممتحنة',
		firstPage: 549,
		lastPage: 551,
	},
	{
		id: 61,
		firstVerseId: 5164,
		lastVerseId: 5177,
		name: 'As-Saff',
		ohneharakat: 'سورة الصَّف',
		withoutHarakat: 'سورة الصف',
		firstPage: 551,
		lastPage: 552,
	},
	{
		id: 62,
		firstVerseId: 5178,
		lastVerseId: 5188,
		name: 'Al-Jumua',
		ohneharakat: 'سورة الجُمُعَة',
		withoutHarakat: 'سورة الجمعة',
		firstPage: 553,
		lastPage: 554,
	},
	{
		id: 63,
		firstVerseId: 5189,
		lastVerseId: 5199,
		name: 'Al-Munafiqoon',
		ohneharakat: 'سورة المنَافِقون',
		withoutHarakat: 'سورة المنافقون',
		firstPage: 554,
		lastPage: 555,
	},
	{
		id: 64,
		firstVerseId: 5200,
		lastVerseId: 5217,
		name: 'At-Taghabun',
		ohneharakat: 'سورة التغَابُن',
		withoutHarakat: 'سورة التغابن',
		firstPage: 556,
		lastPage: 557,
	},
	{
		id: 65,
		firstVerseId: 5218,
		lastVerseId: 5229,
		name: 'At-Talaq',
		ohneharakat: 'سورة الطلَاق',
		withoutHarakat: 'سورة الطلاق',
		firstPage: 558,
		lastPage: 559,
	},
	{
		id: 66,
		firstVerseId: 5230,
		lastVerseId: 5241,
		name: 'At-Tahrim',
		ohneharakat: 'سورة التحْريم',
		withoutHarakat: 'سورة التحريم',
		firstPage: 560,
		lastPage: 561,
	},
	{
		id: 67,
		firstVerseId: 5242,
		lastVerseId: 5271,
		name: 'Al-Mulk',
		ohneharakat: 'سورة المُلْك',
		withoutHarakat: 'سورة الملك',
		firstPage: 562,
		lastPage: 564,
	},
	{
		id: 68,
		firstVerseId: 5272,
		lastVerseId: 5323,
		name: 'Al-Qalam',
		ohneharakat: 'سورة القَلَم',
		withoutHarakat: 'سورة القلم',
		firstPage: 564,
		lastPage: 566,
	},
	{
		id: 69,
		firstVerseId: 5324,
		lastVerseId: 5375,
		name: 'Al-Haaqqa',
		ohneharakat: 'سورة الحَاقَّة',
		withoutHarakat: 'سورة الحاقة',
		firstPage: 566,
		lastPage: 568,
	},
	{
		id: 70,
		firstVerseId: 5376,
		lastVerseId: 5419,
		name: 'Al-Maarij',
		ohneharakat: 'سورة المعَارج',
		withoutHarakat: 'سورة المعارج',
		firstPage: 568,
		lastPage: 570,
	},
	{
		id: 71,
		firstVerseId: 5420,
		lastVerseId: 5447,
		name: 'Nooh',
		ohneharakat: 'سورة نُوح',
		withoutHarakat: 'سورة نوح',
		firstPage: 570,
		lastPage: 571,
	},
	{
		id: 72,
		firstVerseId: 5448,
		lastVerseId: 5475,
		name: 'Al-Jinn',
		ohneharakat: 'سورة الجِن',
		withoutHarakat: 'سورة الجن',
		firstPage: 572,
		lastPage: 573,
	},
	{
		id: 73,
		firstVerseId: 5476,
		lastVerseId: 5495,
		name: 'Al-Muzzammil',
		ohneharakat: 'سورة المُزَّمِّل',
		withoutHarakat: 'سورة المزمل',
		firstPage: 574,
		lastPage: 575,
	},
	{
		id: 74,
		firstVerseId: 5496,
		lastVerseId: 5551,
		name: 'Al-Muddathir',
		ohneharakat: 'سورة المُدَّثِّر',
		withoutHarakat: 'سورة المدثر',
		firstPage: 575,
		lastPage: 577,
	},
	{
		id: 75,
		firstVerseId: 5552,
		lastVerseId: 5591,
		name: 'Al-Qiyama',
		ohneharakat: 'سورة القِيَامَة',
		withoutHarakat: 'سورة القيامة',
		firstPage: 577,
		lastPage: 578,
	},
	{
		id: 76,
		firstVerseId: 5592,
		lastVerseId: 5622,
		name: 'Al-Insan',
		ohneharakat: 'سورة الإنسَان',
		withoutHarakat: 'سورة الانسان',
		firstPage: 578,
		lastPage: 580,
	},
	{
		id: 77,
		firstVerseId: 5623,
		lastVerseId: 5672,
		name: 'Al-Mursalat',
		ohneharakat: 'سورة المُرسَلات',
		withoutHarakat: 'سورة المرسلات',
		firstPage: 580,
		lastPage: 581,
	},
	{
		id: 78,
		firstVerseId: 5673,
		lastVerseId: 5712,
		name: 'An-Naba',
		ohneharakat: 'سورة النَّبَأ',
		withoutHarakat: 'سورة النبأ',
		firstPage: 582,
		lastPage: 583,
	},
	{
		id: 79,
		firstVerseId: 5713,
		lastVerseId: 5758,
		name: 'An-Naziat',
		ohneharakat: 'سورة النّازعَات',
		withoutHarakat: 'سورة النازعات',
		firstPage: 583,
		lastPage: 584,
	},
	{
		id: 80,
		firstVerseId: 5759,
		lastVerseId: 5800,
		name: 'Abasa',
		ohneharakat: 'سورة عَبَس',
		withoutHarakat: 'سورة عبس',
		firstPage: 585,
		lastPage: 585,
	},
	{
		id: 81,
		firstVerseId: 5801,
		lastVerseId: 5829,
		name: 'At-Takwir',
		ohneharakat: 'سورة التَّكوير',
		withoutHarakat: 'سورة التكوير',
		firstPage: 586,
		lastPage: 586,
	},
	{
		id: 82,
		firstVerseId: 5830,
		lastVerseId: 5848,
		name: 'Al-Infitar',
		ohneharakat: 'سورة الانفِطار',
		withoutHarakat: 'سورة الانفطار',
		firstPage: 587,
		lastPage: 587,
	},
	{
		id: 83,
		firstVerseId: 5849,
		lastVerseId: 5884,
		name: 'Al-Mutaffifin',
		ohneharakat: 'سورة المطفِّفِين',
		withoutHarakat: 'سورة المطففين',
		firstPage: 587,
		lastPage: 589,
	},
	{
		id: 84,
		firstVerseId: 5885,
		lastVerseId: 5909,
		name: 'Al-Inshiqaq',
		ohneharakat: 'سورة الانْشِقَاق',
		withoutHarakat: 'سورة الانشقاق',
		firstPage: 589,
		lastPage: 590,
	},
	{
		id: 85,
		firstVerseId: 5910,
		lastVerseId: 5931,
		name: 'Al-Burooj',
		ohneharakat: 'سورة البرُوج',
		withoutHarakat: 'سورة البروج',
		firstPage: 590,
		lastPage: 591,
	},
	{
		id: 86,
		firstVerseId: 5932,
		lastVerseId: 5948,
		name: 'At-Tariq',
		ohneharakat: 'سورة الطَّارِق',
		withoutHarakat: 'سورة الطارق',
		firstPage: 591,
		lastPage: 591,
	},
	{
		id: 87,
		firstVerseId: 5949,
		lastVerseId: 5967,
		name: 'Al-Ala',
		ohneharakat: 'سورة الأَعْلى',
		withoutHarakat: 'سورة الاعلى',
		firstPage: 591,
		lastPage: 592,
	},
	{
		id: 88,
		firstVerseId: 5968,
		lastVerseId: 5993,
		name: 'Al-Ghashiya',
		ohneharakat: 'سورة الغَاشِية',
		withoutHarakat: 'سورة الغاشية',
		firstPage: 592,
		lastPage: 593,
	},
	{
		id: 89,
		firstVerseId: 5994,
		lastVerseId: 6023,
		name: 'Al-Fajr',
		ohneharakat: 'سورة الفَجْر',
		withoutHarakat: 'سورة الفجر',
		firstPage: 593,
		lastPage: 595,
	},
	{
		id: 90,
		firstVerseId: 6024,
		lastVerseId: 6043,
		name: 'Al-Balad',
		ohneharakat: 'سورة البَلَد',
		withoutHarakat: 'سورة البلد',
		firstPage: 595,
		lastPage: 596,
	},
	{
		id: 91,
		firstVerseId: 6044,
		lastVerseId: 6058,
		name: 'Ash-Shams',
		ohneharakat: 'سورة الشَّمْس',
		withoutHarakat: 'سورة الشمس',
		firstPage: 595,
		lastPage: 595,
	},
	{
		id: 92,
		firstVerseId: 6059,
		lastVerseId: 6079,
		name: 'Al-Lail',
		ohneharakat: 'سورة الليْل',
		withoutHarakat: 'سورة الليل',
		firstPage: 595,
		lastPage: 596,
	},
	{
		id: 93,
		firstVerseId: 6080,
		lastVerseId: 6090,
		name: 'Ad-Dhuha',
		ohneharakat: 'سورة الضُّحَى',
		withoutHarakat: 'سورة الضحى',
		firstPage: 596,
		lastPage: 596,
	},
	{
		id: 94,
		firstVerseId: 6091,
		lastVerseId: 6098,
		name: 'Al-Inshirah',
		ohneharakat: 'سورة الشَّرْح',
		withoutHarakat: 'سورة الشرح',
		firstPage: 596,
		lastPage: 596,
	},
	{
		id: 95,
		firstVerseId: 6099,
		lastVerseId: 6106,
		name: 'At-Tin',
		ohneharakat: 'سورة التِّين',
		withoutHarakat: 'سورة التين',
		firstPage: 597,
		lastPage: 597,
	},
	{
		id: 96,
		firstVerseId: 6107,
		lastVerseId: 6125,
		name: 'Al-Alaq',
		ohneharakat: 'سورة العَلَق',
		withoutHarakat: 'سورة العلق',
		firstPage: 597,
		lastPage: 598,
	},
	{
		id: 97,
		firstVerseId: 6126,
		lastVerseId: 6130,
		name: 'Al-Qadr',
		ohneharakat: 'سورة القَدْر',
		withoutHarakat: 'سورة القدر',
		firstPage: 598,
		lastPage: 598,
	},
	{
		id: 98,
		firstVerseId: 6131,
		lastVerseId: 6138,
		name: 'Al-Bayyina',
		ohneharakat: 'سورة البَينَة',
		withoutHarakat: 'سورة البينة',
		firstPage: 598,
		lastPage: 599,
	},
	{
		id: 99,
		firstVerseId: 6139,
		lastVerseId: 6146,
		name: 'Al-Zalzala',
		ohneharakat: 'سورة الزلزَلة',
		withoutHarakat: 'سورة الزلزلة',
		firstPage: 599,
		lastPage: 599,
	},
	{
		id: 100,
		firstVerseId: 6147,
		lastVerseId: 6157,
		name: 'Al-Adiyat',
		ohneharakat: 'سورة العَادِيات',
		withoutHarakat: 'سورة العاديات',
		firstPage: 599,
		lastPage: 600,
	},
	{
		id: 101,
		firstVerseId: 6158,
		lastVerseId: 6168,
		name: 'Al-Qaria',
		ohneharakat: 'سورة القَارِعة',
		withoutHarakat: 'سورة القارعة',
		firstPage: 600,
		lastPage: 600,
	},
	{
		id: 102,
		firstVerseId: 6169,
		lastVerseId: 6176,
		name: 'At-Takathur',
		ohneharakat: 'سورة التَّكَاثر',
		withoutHarakat: 'سورة التكاثر',
		firstPage: 600,
		lastPage: 601,
	},
	{
		id: 103,
		firstVerseId: 6177,
		lastVerseId: 6179,
		name: 'Al-Asr',
		ohneharakat: 'سورة العَصْر',
		withoutHarakat: 'سورة العصر',
		firstPage: 601,
		lastPage: 601,
	},
	{
		id: 104,
		firstVerseId: 6180,
		lastVerseId: 6188,
		name: 'Al-Humaza',
		ohneharakat: 'سورة الهُمَزَة',
		withoutHarakat: 'سورة الهمزة',
		firstPage: 601,
		lastPage: 601,
	},
	{
		id: 105,
		firstVerseId: 6189,
		lastVerseId: 6193,
		name: 'Al-Fil',
		ohneharakat: 'سورة الفِيل',
		withoutHarakat: 'سورة الفيل',
		firstPage: 601,
		lastPage: 601,
	},
	{
		id: 106,
		firstVerseId: 6194,
		lastVerseId: 6197,
		name: 'Quraish',
		ohneharakat: 'سورة قُرَيْش',
		withoutHarakat: 'سورة قريش',
		firstPage: 602,
		lastPage: 602,
	},
	{
		id: 107,
		firstVerseId: 6198,
		lastVerseId: 6204,
		name: 'Al-Maun',
		ohneharakat: 'سورة المَاعُون',
		withoutHarakat: 'سورة الماعون',
		firstPage: 602,
		lastPage: 602,
	},
	{
		id: 108,
		firstVerseId: 6205,
		lastVerseId: 6207,
		name: 'Al-Kauther',
		ohneharakat: 'سورة الكَوْثَر',
		withoutHarakat: 'سورة الكوثر',
		firstPage: 602,
		lastPage: 602,
	},
	{
		id: 109,
		firstVerseId: 6208,
		lastVerseId: 6213,
		name: 'Al-Kafiroon',
		ohneharakat: 'سورة الكَافِرُون',
		withoutHarakat: 'سورة الكافرون',
		firstPage: 603,
		lastPage: 603,
	},
	{
		id: 110,
		firstVerseId: 6214,
		lastVerseId: 6216,
		name: 'An-Nasr',
		ohneharakat: 'سورة النَّصر',
		withoutHarakat: 'سورة النصر',
		firstPage: 603,
		lastPage: 603,
	},
	{
		id: 111,
		firstVerseId: 6217,
		lastVerseId: 6221,
		name: 'Al-Masadd',
		ohneharakat: 'سورة المَسَد',
		withoutHarakat: 'سورة المسد',
		firstPage: 603,
		lastPage: 603,
	},
	{
		id: 112,
		firstVerseId: 6222,
		lastVerseId: 6225,
		name: 'Al-Ikhlas',
		ohneharakat: 'سورة الإخْلَاص',
		withoutHarakat: 'سورة الاخلاص',
		firstPage: 604,
		lastPage: 604,
	},
	{
		id: 113,
		firstVerseId: 6226,
		lastVerseId: 6230,
		name: 'Al-Falaq',
		ohneharakat: 'سورة الفَلَق',
		withoutHarakat: 'سورة الفلق',
		firstPage: 604,
		lastPage: 604,
	},
	{
		id: 114,
		firstVerseId: 6231,
		lastVerseId: 6236,
		name: 'An-Nas',
		ohneharakat: 'سورة النَّاس',
		withoutHarakat: 'سورة الناس',
		firstPage: 604,
		lastPage: 604,
	},
];
